const reservationDateOptionValueSeparator = ":";

export const createReservationDateOptionValue = (date: string, index: number) =>
  `${index}${reservationDateOptionValueSeparator}${date}`;

export const getReservationDateFromOptionValue = (
  dateOptionValue: string | undefined
) => {
  if (!dateOptionValue) {
    return dateOptionValue;
  }

  const separatorIndex = dateOptionValue.indexOf(
    reservationDateOptionValueSeparator
  );
  if (separatorIndex === -1) {
    return dateOptionValue;
  }

  return dateOptionValue.slice(separatorIndex + 1);
};

export const findReservationDateOptionValue = (
  dates: { date: string }[],
  date: string | undefined
) => {
  if (!date) {
    return date;
  }

  const index = dates.findIndex((d) => d.date === date);
  if (index === -1) {
    return date;
  }

  return createReservationDateOptionValue(date, index);
};
